/*!
 * DEATH BY CROSS — Arara interativa ("rail")
 * Componente isolado, sem dependências. Expõe window.DBCRail.
 *
 *   const rail = new DBCRail(elemento, { products: [...], config: {...} });
 *   rail.destroy();
 *
 * Estados (data-state no elemento raiz):
 *   rest       nenhuma peça destacada (todas de perfil)
 *   highlight  uma peça de frente
 *   opening    transição para a visualização ampliada
 *   expanded   visualização ampliada aberta
 *   closing    transição de volta para a arara
 */
(function (global) {
  'use strict';

  var DEFAULTS = {
    // ----- imagens -----
    assetBase: '',            // prefixo aplicado a caminhos relativos das imagens
    canvasAspect: 0.75,       // largura/altura do canvas das imagens (1200x1600 = .75)
    hookY: 0.0425,            // altura da linha da barra dentro da imagem (fração da altura)
    contentBottom: 0.9,       // até onde a roupa vai na imagem (corta margem inferior)
    fallbackSideScale: 0.32,  // usado SÓ se a imagem lateral faltar (provisório)

    // ----- composição (computador) -----
    itemHeight: 440,          // altura do canvas da peça em px
    scale: 1,                 // multiplicador geral de escala das peças
    restSpacing: 74,          // distância entre cabides em repouso (px)
    activeSpacing: 300,       // largura reservada para a peça de frente (px)
    railTop: 36,              // distância do topo da área até o centro da barra (px)
    railThickness: 0,         // 0 = automático (2.4% da altura da peça)
    railInset: 24,            // recuo da barra nas laterais (px)
    edgePadding: 72,          // margem lateral do conteúdo quando há rolagem (px)
    initialIndex: -1,         // -1 = começa em repouso no computador

    // ----- movimento -----
    duration: 0.55,           // duração aproximada das transições (s)
    motion: 1,                // intensidade geral (0 = sem giro/oscilação)
    turnAngle: 80,            // ângulo de giro simulado (graus)
    activeScale: 1.035,       // leve avanço da peça ativa
    sway: 1,                  // intensidade da oscilação residual
    maxSway: 3.2,             // limite da oscilação (graus)
    leaveDelay: 420,          // ms até voltar ao repouso ao sair com o cursor
    resetOnLeave: true,       // false = mantém a última peça de frente

    // ----- interface -----
    showCaption: true,        // nome do produto abaixo da arara
    showOpenButton: true,     // botão "Ver peça"
    showPriceTag: true,       // etiqueta de preço pendurada no cabide
    itemShadow: true,         // sombra CSS (desligue se a imagem já tiver sombra)
    modalShowTitle: true,     // nome do produto na visualização ampliada
    currency: 'BRL',
    locale: 'pt-BR',
    tagY: 0.082,              // altura da etiqueta no canvas (fração)

    // ----- toque / celular -----
    mobileBreakpoint: 640,    // abaixo disso: modo toque
    mobileItemHeight: 400,
    mobileSlot: 0.42,         // largura de cada posição (fração da largura)

    // ----- visualização ampliada -----
    modalHeight: '66vh',
    modalZIndex: 1000,
    openDuration: 0.56,

    // ----- tema (vira variáveis CSS) -----
    theme: {
      background: null,       // ex.: '#000' ou 'url(fundo.jpg) center/cover'
      text: null,
      muted: null,
      accent: null,
      railLight: null,
      railMid: null,
      railDark: null,
      font: null,
      captionSize: null,
      modalBackground: null
    },

    labels: {
      rest: 'Passe o cursor pelas peças',
      restTouch: 'Toque numa peça para ver a frente',
      open: 'Ver peça',
      openAria: 'Ampliar',
      front: 'Frente',
      back: 'Costas',
      backMissing: 'Costas indisponível',
      close: 'Fechar',
      prev: 'Peças anteriores',
      next: 'Próximas peças',
      product: 'Ver produto',
      price: 'Preço',
      collection: 'Arara de peças',
      views: 'Vista'
    }
  };

  var THEME_VARS = {
    background: '--dbca-bg', text: '--dbca-text', muted: '--dbca-muted', accent: '--dbca-accent',
    railLight: '--dbca-rail-light', railMid: '--dbca-rail-mid', railDark: '--dbca-rail-dark',
    font: '--dbca-font', captionSize: '--dbca-caption-size', modalBackground: '--dbca-modal-bg'
  };

  var FALLBACK_IMG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1600">' +
    '<path d="M600 172 L600 130 C600 112 572 106 572 74 A28 28 0 1 1 628 68" fill="none" stroke="#777" stroke-width="11" stroke-linecap="round"/>' +
    '<path d="M532 236 C560 270 640 270 668 236 L858 300 L870 1380 C700 1400 500 1400 330 1380 L342 300 Z" fill="none" stroke="#666" stroke-width="6" stroke-dasharray="18 14"/>' +
    '<text x="600" y="820" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="38" letter-spacing="6" fill="#888">IMAGEM</text>' +
    '<text x="600" y="870" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="38" letter-spacing="6" fill="#888">INDISPONÍVEL</text></svg>');

  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var uid = 0;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function merge(base, over) {
    var out = {};
    for (var k in base) out[k] = base[k];
    if (over) for (var j in over) if (over[j] !== undefined) out[j] = over[j];
    return out;
  }
  function fmtPrice(v, cfg) {
    if (v === '' || v == null) return '';
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
    if (isNaN(n)) return String(v);
    try {
      return new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency,
        minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
    } catch (e) { return 'R$ ' + n; }
  }
  function raf(fn) { return (global.requestAnimationFrame || setTimeout)(fn); }
  function caf(id) { return (global.cancelAnimationFrame || clearTimeout)(id); }

  // ======================================================================
  function DBCRail(root, options) {
    if (!(this instanceof DBCRail)) return new DBCRail(root, options);
    if (typeof root === 'string') root = document.querySelector(root);
    if (!root) throw new Error('DBCRail: elemento não encontrado');
    if (root.__dbcRail) root.__dbcRail.destroy();
    root.__dbcRail = this;

    options = options || {};
    var data = {};
    var dataEl = root.querySelector('script[type="application/json"][data-dbca]');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch (e) { console.warn('DBCRail: JSON inválido', e); }
    }
    var dc = data.config || {}, oc = options.config || {};
    var cfg = merge(merge(DEFAULTS, dc), oc);
    cfg.theme = merge(merge(DEFAULTS.theme, dc.theme), oc.theme);
    cfg.labels = merge(merge(DEFAULTS.labels, dc.labels), oc.labels);

    this.root = root;
    this.config = cfg;
    this.id = 'dbca' + (++uid);
    this._originalHTML = root.innerHTML;
    this._originalClass = root.className;
    this._originalStyle = root.getAttribute('style');
    this._ls = [];
    this.state = 'rest';
    this.active = -1;
    this.mode = null;
    this.view = 'front';
    this._loop = 0;
    this._last = 0;
    this._pointer = null;

    this._mqReduce = global.matchMedia ? global.matchMedia('(prefers-reduced-motion: reduce)') : null;
    this._mqTouch = global.matchMedia ? global.matchMedia('(hover: none) and (pointer: coarse)') : null;
    this.reduced = !!(this._mqReduce && this._mqReduce.matches);

    this.products = this._normalize(options.products || data.products || []);
    this._build();
    this._bind();
    this._measure(true);
  }

  var P = DBCRail.prototype;

  // ---------------------------------------------------------------- dados
  P._resolve = function (path) {
    if (!path) return null;
    if (/^(https?:|data:|blob:|\/)/i.test(path)) return path;
    return (this.config.assetBase || '') + path;
  };
  P._normalize = function (list) {
    var self = this;
    return list.map(function (p, i) {
      var img = p.images || {};
      return {
        id: p.id || ('item-' + i),
        title: p.title || 'Peça ' + (i + 1),
        subtitle: p.subtitle || '',
        price: fmtPrice(p.price, self.config),
        url: p.url || '',
        handle: p.handle || '',
        data: p,
        images: { side: self._resolve(img.side), front: self._resolve(img.front), back: self._resolve(img.back) }
      };
    });
  };

  // ---------------------------------------------------------------- DOM
  P._applyTheme = function (el) {
    var t = this.config.theme;
    for (var k in THEME_VARS) if (t[k] != null && t[k] !== '') el.style.setProperty(THEME_VARS[k], t[k]);
  };

  P._build = function () {
    var cfg = this.config, L = cfg.labels, root = this.root, self = this;
    root.classList.add('dbca');
    root.classList.toggle('no-shadow', !cfg.itemShadow);
    root.style.setProperty('--dbca-tag-y', (cfg.tagY * 100) + '%');
    root.setAttribute('data-state', 'rest');
    root.setAttribute('data-active', '-1');
    this._applyTheme(root);

    var h = '';
    h += '<div class="dbca-viewport">';
    h += '<div class="dbca-scroller">';
    h += '<div class="dbca-stage" role="group" aria-label="' + esc(L.collection) + '">';
    h += '<div class="dbca-rail" aria-hidden="true"><span class="dbca-rail-cap dbca-rail-cap--l"></span><span class="dbca-rail-cap dbca-rail-cap--r"></span></div>';
    this.products.forEach(function (p, i) {
      h += '<span class="dbca-snap" aria-hidden="true"></span>';
      h += '<button type="button" class="dbca-item" data-index="' + i + '" tabindex="-1" aria-label="' + esc(p.title + (p.price ? ', ' + p.price : '')) + '">' +
           '<span class="dbca-swing">' +
           '<span class="dbca-shadow"></span>' +
           '<img class="dbca-img dbca-img--side" alt="" draggable="false" decoding="async">' +
           '<img class="dbca-img dbca-img--front" alt="" draggable="false" decoding="async">' +
           '<span class="dbca-focus"></span>' +
           (cfg.showPriceTag && p.price ? '<span class="dbca-tag" aria-hidden="true"><span class="dbca-tag-card">' + esc(p.price) + '</span></span>' : '') +
           '</span>' +
           (cfg.hoverLabel ? '<span class="dbca-label" aria-hidden="true">' + esc(p.title) + '</span>' : '') +
           '</button>';
    });
    h += '</div></div>';
    h += '<button type="button" class="dbca-nav dbca-nav--prev" aria-label="' + esc(L.prev) + '">' + ICON_PREV + '</button>';
    h += '<button type="button" class="dbca-nav dbca-nav--next" aria-label="' + esc(L.next) + '">' + ICON_NEXT + '</button>';
    h += '</div>';
    h += '<div class="dbca-caption"' + (cfg.showCaption ? '' : ' hidden') + '>' +
         '<div class="dbca-names"><span class="dbca-name is-current is-hint"></span><span class="dbca-name" aria-hidden="true"></span></div>' +
         '<div class="dbca-sub"></div>' +
         '<button type="button" class="dbca-open"' + (cfg.showOpenButton ? '' : ' hidden') + '>' + esc(L.open) + '</button>' +
         '</div>';
    root.innerHTML = h;

    this.scroller = root.querySelector('.dbca-scroller');
    this.stage = root.querySelector('.dbca-stage');
    this.btnPrev = root.querySelector('.dbca-nav--prev');
    this.btnNext = root.querySelector('.dbca-nav--next');
    this.btnOpen = root.querySelector('.dbca-open');
    this.nameEls = root.querySelectorAll('.dbca-name');
    this.subEl = root.querySelector('.dbca-sub');
    this.nameEls[0].textContent = L.rest;

    var snaps = root.querySelectorAll('.dbca-snap');
    this.items = Array.prototype.map.call(root.querySelectorAll('.dbca-item'), function (el, i) {
      var it = {
        i: i, el: el,
        swing: el.querySelector('.dbca-swing'),
        side: el.querySelector('.dbca-img--side'),
        front: el.querySelector('.dbca-img--front'),
        shadow: el.querySelector('.dbca-shadow'),
        label: el.querySelector('.dbca-label'),
        snap: snaps[i],
        x: 0, vx: 0, tx: 0, ax: 0,
        p: 0, vp: 0, tp: 0,
        th: 0, vth: 0,
        frontReady: false, sideFallback: false,
        cache: {}
      };
      snaps[i].style.cssText = 'position:absolute;top:0;height:1px;scroll-snap-align:center;pointer-events:none';
      self._loadItemImages(it);
      return it;
    });
  };

  P._loadItemImages = function (it) {
    var self = this, p = this.products[it.i];
    var front = it.front, side = it.side;

    var shown = function () { it.el.classList.add('is-loaded'); };
    side.addEventListener('load', shown);
    setTimeout(shown, 4000);   // nunca deixa a peça invisível por falha de rede
    function markReady() {
      var done = function () { it.frontReady = true; it.cache = {}; self._kick(); };
      if (front.decode) front.decode().then(done, done); else done();
    }
    front.addEventListener('load', markReady);
    front.addEventListener('error', function () {
      if (front.src !== FALLBACK_IMG) {
        console.warn('DBCRail: imagem frontal indisponível —', p.title, p.images.front);
        it.el.classList.add('is-broken');
        front.src = FALLBACK_IMG;
      }
    });
    side.addEventListener('error', function () {
      // Limitação provisória: sem foto lateral, usa a frente comprimida.
      if (!it.sideFallback && p.images.front) {
        console.warn('DBCRail: imagem lateral indisponível — usando frente comprimida (provisório):', p.title);
        it.sideFallback = true; it.cache = {};
        side.src = p.images.front;
        self._kick();
      } else if (side.src !== FALLBACK_IMG) {
        it.el.classList.add('is-broken');
        side.src = FALLBACK_IMG;
      }
    });
    if (!p.images.side) { it.sideFallback = true; side.src = p.images.front || FALLBACK_IMG; }
    else side.src = p.images.side;
    front.src = p.images.front || FALLBACK_IMG;
  };

  P._preloadBack = function (i) {
    var p = this.products[i];
    if (!p || !p.images.back || p._backRequested) return;
    p._backRequested = true;
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { p._backOk = true; };
    im.onerror = function () { p._backOk = false; p._backFailed = true; };
    im.src = p.images.back;
  };

  // ---------------------------------------------------------------- eventos
  P._on = function (t, type, fn, opts) {
    t.addEventListener(type, fn, opts);
    this._ls.push([t, type, fn, opts]);
  };

  P._bind = function () {
    var self = this;

    this._on(this.stage, 'pointermove', function (e) {
      if (e.pointerType === 'touch' || self.mode !== 'desktop') return;
      self._pointer = { x: e.clientX, y: e.clientY };
      self._hover();
    });
    this._on(this.stage, 'pointerdown', function (e) {
      if (e.pointerType !== 'touch') self._pointer = { x: e.clientX, y: e.clientY };
    });
    this._on(this.scroller, 'pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      self._pointer = null;
      self._scheduleLeave();
    });
    this._on(this.stage, 'click', function (e) {
      var btn = e.target.closest && e.target.closest('.dbca-item');
      if (btn && e.detail === 0) {             // teclado (Enter/Espaço)
        self.open(+btn.getAttribute('data-index'), btn);
        return;
      }
      var x = e.clientX - self._stageLeft();
      if (self.mode === 'touch') {
        // soltar o dedo depois de deslizar não seleciona nada
        if (self._tMoved || Math.abs(self.scroller.scrollLeft - self._tScroll0) > 2) return;
        var ti = self._touchIndexAt(x);
        if (ti < 0) return;
        if (ti !== self.active) {
          self.setActive(ti);
          self._progScroll = true;               // centraliza sem fechar a peça
          clearTimeout(self._progT); self._progT = setTimeout(function () { self._progScroll = false; }, 800);
          self._scrollTo(ti * self._L.S);
        }
        return;
      }
      var idx = self._hitIndex(x, self.active);
      if (idx < 0) return;
      if (idx === self.active) self.open(idx, self.items[idx].el);
      else self.setActive(idx);
    });

    // teclado: roving tabindex
    this._on(this.stage, 'focusin', function (e) {
      var btn = e.target.closest && e.target.closest('.dbca-item');
      if (!btn) return;
      var i = +btn.getAttribute('data-index');
      self._clearLeave();
      if (self.mode === 'touch') { if (!self._tDown && i !== self.active && e.target.matches(':focus-visible')) self.scrollToIndex(i); }
      else { self.setActive(i); self._ensureVisible(i); }
    });
    this._on(this.stage, 'focusout', function (e) {
      if (self.mode !== 'desktop' || !self.config.resetOnLeave) return;
      if (e.relatedTarget && self.root.contains(e.relatedTarget)) return;
      if (self.state !== 'highlight' || self._pointer) return;
      self._scheduleLeave();
    });
    this._on(this.stage, 'keydown', function (e) {
      var k = e.key, n = self.items.length, cur = self.active < 0 ? 0 : self.active, to = -1;
      if (k === 'ArrowRight') to = Math.min(n - 1, cur + 1);
      else if (k === 'ArrowLeft') to = Math.max(0, cur - 1);
      else if (k === 'Home') to = 0;
      else if (k === 'End') to = n - 1;
      if (to < 0) return;
      e.preventDefault();
      self.items[to].el.focus({ preventScroll: true });
    });

    this._on(this.scroller, 'scroll', function () {
      if (self._scrollRaf) return;
      self._scrollRaf = raf(function () {
        self._scrollRaf = 0;
        self._updateNav();
        if (self.mode === 'touch') {
          if (self._progScroll) return;
          if (self.active >= 0 && self._tMoved && (self.state === 'highlight' || self.state === 'rest')) self.setActive(-1);
        } else if (self._pointer) self._hover();
      });
    }, { passive: true });

    // toque x arraste: registra o início e acompanha o deslocamento
    var TAP = this.config.tapThreshold || 10;
    this._tMoved = false; this._tScroll0 = 0;
    this._on(this.scroller, 'touchstart', function (e) {
      var t = e.touches[0]; if (!t) return;
      self._tDown = true; self._tMoved = false; self._tX = t.clientX; self._tY = t.clientY;
      self._tScroll0 = self.scroller.scrollLeft; self._progScroll = false;
    }, { passive: true });
    this._on(this.scroller, 'touchmove', function (e) {
      var t = e.touches[0]; if (!t || self._tMoved) return;
      var dx = t.clientX - self._tX, dy = t.clientY - self._tY;
      if (Math.abs(dx) > TAP || Math.abs(dy) > TAP) {
        self._tMoved = true;
        // arraste horizontal com peça aberta: ela volta de lado
        if (Math.abs(dx) > Math.abs(dy) && self.mode === 'touch' && self.active >= 0) self.setActive(-1);
      }
    }, { passive: true });
    var tEnd = function () { self._tDown = false; setTimeout(function () { if (!self._tDown) self._tMoved = false; }, 450); };
    this._on(this.scroller, 'touchend', tEnd, { passive: true });
    this._on(this.scroller, 'touchcancel', function () { self._tDown = false; self._tMoved = true; tEnd(); }, { passive: true });
    if ('onscrollend' in global) this._on(this.scroller, 'scrollend', function () { self._progScroll = false; });

    this._on(this.btnPrev, 'click', function () { self._page(-1); });
    this._on(this.btnNext, 'click', function () { self._page(1); });
    this._on(this.btnOpen, 'click', function () { if (self.active >= 0) self.open(self.active, self.btnOpen); });

    var onReduce = function () { self.reduced = self._mqReduce.matches; self._snapAll(); };
    if (this._mqReduce) {
      if (this._mqReduce.addEventListener) this._on(this._mqReduce, 'change', onReduce);
      else if (this._mqReduce.addListener) { this._mqReduce.addListener(onReduce); this._legacyMq = onReduce; }
    }

    if (global.ResizeObserver) {
      this._ro = new ResizeObserver(function () {
        if (self._roRaf) return;
        self._roRaf = raf(function () { self._roRaf = 0; self._measure(false); });
      });
      this._ro.observe(this.root);
    } else {
      this._on(global, 'resize', function () { self._measure(false); });
    }
    if (this.config.fitViewport) {
      this._on(global, 'resize', function () { self._measure(false); });
      this._on(global, 'load', function () { self._measure(false); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self._measure(false); });
    }
    this._on(global, 'orientationchange', function () { setTimeout(function () { self._measure(false); }, 250); });
  };

  // topo usado para caber na tela: no topo da página é a posição real; numa seção mais abaixo
  // (home) é a altura do cabeçalho grudado + a distância do começo da seção até a arara
  P._fitTop = function (vh) {
    var sy = global.pageYOffset || 0, root = this.root;
    var docTop = root.getBoundingClientRect().top + sy;
    var cont = root.closest ? root.closest('.collection-page') : null;
    if (!cont) return Math.round(docTop);
    var ct = cont.getBoundingClientRect().top + sy;
    if (ct < vh * 0.5) return Math.round(docTop);
    var b = 0;
    var hdrs = document.querySelectorAll('body *');
    for (var i = 0; i < hdrs.length && i < 400; i++) {
      var e = hdrs[i];
      if (e === cont || cont.contains(e) || e.contains(cont)) continue;
      var cs = getComputedStyle(e);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var r = e.getBoundingClientRect(), t = parseFloat(cs.top);
      if (r.height <= 0 || r.height > vh * 0.4 || r.width < global.innerWidth * 0.5) continue;
      var stuck = cs.position === 'fixed' ? (r.top <= 2 ? r.bottom : 0) : (isNaN(t) ? 0 : t + r.height);
      if (stuck < vh * 0.4) b = Math.max(b, stuck);
    }
    cont.style.scrollMarginTop = Math.round(b) + 'px';
    cont.style.minHeight = Math.round(vh - b) + 'px';
    return Math.round(b + (docTop - ct));
  };

  P._stageLeft = function () {
    return this.scroller.getBoundingClientRect().left - this.scroller.scrollLeft;
  };

  P._hover = function () {
    if (!this._pointer || (this.state !== 'rest' && this.state !== 'highlight')) return;
    var x = this._pointer.x - this._stageLeft();
    var idx = this._hitIndex(x, this.active);
    if (idx >= 0) { this._clearLeave(); this.setActive(idx); }
    else this._scheduleLeave();
  };

  P._scheduleLeave = function () {
    if (this.mode !== 'desktop' || !this.config.resetOnLeave) return;
    var self = this;
    this._clearLeave();
    this._leaveT = setTimeout(function () {
      self._leaveT = 0;
      if (self.state !== 'highlight') return;
      var f = document.activeElement;
      if (f && self.stage.contains(f) && f.matches && f.matches(':focus-visible')) return;
      self.setActive(-1);
    }, this.config.leaveDelay);
  };
  P._clearLeave = function () { if (this._leaveT) { clearTimeout(this._leaveT); this._leaveT = 0; } };

  // ---------------------------------------------------------------- layout
  P._measure = function (initial) {
    var cfg = this.config, n = this.items.length;
    var w = this.scroller.clientWidth || this.root.clientWidth || 1;
    var touchEnv = this._mqTouch && this._mqTouch.matches;
    var mode = (w < cfg.mobileBreakpoint || touchEnv) ? 'touch' : 'desktop';
    var modeChanged = mode !== this.mode;
    var vhNow = global.innerHeight || 800;
    var topNow = cfg.fitViewport ? this._fitTop(vhNow) : 0;
    var sizeChanged = w !== this._w || (cfg.fitViewport && (vhNow !== this._vh || topNow !== this._top));
    this._vh = vhNow; this._top = topNow;
    if (!initial && !modeChanged && !sizeChanged) return;
    this.mode = mode;
    this._w = w;
    this.root.setAttribute('data-mode', mode);

    var H;
    if (mode === 'touch') {
      var vh = global.innerHeight || 800;
      H = Math.min(cfg.mobileItemHeight * cfg.scale, vh * (cfg.mobileVh || 0.62), w * (cfg.mobileWidthK || 99));
    } else {
      H = cfg.itemHeight * cfg.scale;
      var fit = 1;
      if (cfg.fitViewport) {
        // cabe inteira na tela ao entrar na página: altura livre abaixo do topo da arara e largura útil
        var top = topNow;
        var cont2 = this.root.closest ? this.root.closest('.collection-page') : null;
        var foot = cont2 ? cont2.querySelector('.dbc-secbar--bottom') : null;
        var avail = vhNow - top - (cfg.fitBottom || 0) - (foot ? foot.offsetHeight : 0);
        // espaço dentro do componente acima e abaixo do palco (navegação, respiro)
        if (this.stage) {
          var rr = this.root.getBoundingClientRect(), sr = this.stage.getBoundingClientRect();
          avail -= Math.max(0, sr.top - rr.top) + Math.max(0, rr.bottom - sr.bottom);
        }
        var fH = (avail - cfg.railTop) / ((cfg.contentBottom - cfg.hookY) * H);
        var cont0 = n * cfg.restSpacing * cfg.scale + Math.max(0, cfg.activeSpacing - cfg.restSpacing) * cfg.scale;
        var fW = (w - cfg.edgePadding * 2) / cont0;
        fit = Math.max(cfg.fitMin || 0.4, Math.min(1, fH, fW));
        H = H * fit;
      }
      this._fit = fit;
    }
    H = Math.round(H);
    var IW = Math.round(H * cfg.canvasAspect);
    var railTop = cfg.railTop;
    var itemTop = Math.round(railTop - cfg.hookY * H);
    var stageH = Math.round(itemTop + H * cfg.contentBottom);
    var thick = cfg.railThickness || Math.max(6, Math.round(H * 0.024));
    var k = H / 440; // as distâncias padrão são calibradas para 440px

    var L = { H: H, IW: IW, n: n, w: w };
    if (mode === 'touch') {
      // a posição nunca fica mais larga que a peça: em telas largas (paisagem,
      // tablet) aparecem mais vizinhas em vez de peças isoladas nas bordas
      var S = Math.round(Math.min(w * cfg.mobileSlot, IW * 0.62));
      L.S = S; L.pad = (w - S) / 2;
      L.E = Math.max(0, Math.round(IW * (cfg.mobileOpenGap || 0.47) - S));
      L.stageW = Math.round(L.pad * 2 + S * n);
    } else {
      var f = this._fit || 1, R = cfg.restSpacing * cfg.scale * f, A = Math.max(R, cfg.activeSpacing * cfg.scale * f);
      var content = n * R + (A - R);
      L.R = R; L.A = A;
      L.stageW = Math.max(w, Math.round(content + cfg.edgePadding * 2));
      L.offset = (L.stageW - content) / 2;
    }
    void k;
    this._L = L;

    var rs = this.root.style;
    rs.setProperty('--dbca-stage-h', stageH + 'px');
    rs.setProperty('--dbca-item-h', H + 'px');
    rs.setProperty('--dbca-item-w', IW + 'px');
    rs.setProperty('--dbca-item-top', itemTop + 'px');
    rs.setProperty('--dbca-rail-top', railTop + 'px');
    rs.setProperty('--dbca-rail-thick', thick + 'px');
    var inset = cfg.railInset;
    if (mode !== 'touch' && cfg.railHug != null && L.offset != null) inset = Math.max(cfg.railInset, Math.round(L.offset - cfg.railHug));
    if (!n) inset = Math.max(cfg.railInset, Math.round(w * 0.16)); // arara ainda sem peças
    rs.setProperty('--dbca-rail-inset', inset + 'px');
    this.stage.style.width = L.stageW + 'px';
    this.root.classList.toggle('has-overflow', L.stageW > w + 1);

    var self = this;
    this.items.forEach(function (it, i) {
      if (mode === 'touch') {
        it.snap.style.left = (L.pad + i * L.S) + 'px';
        it.snap.style.width = L.S + 'px';
        it.snap.style.display = '';
      } else it.snap.style.display = 'none';
      it.cache = {};
    });

    if (mode === 'touch') {
      var keep = this.active >= 0 ? this.active : -1;
      var first = keep >= 0 ? keep : clamp(cfg.initialIndex >= 0 ? cfg.initialIndex : 0, 0, n - 1);
      this.active = -2; // força atualização
      this.setActive(keep, true);
      this.scroller.scrollLeft = first * L.S;
    } else {
      var a = this.active;
      if (initial && cfg.initialIndex >= 0) a = clamp(cfg.initialIndex, 0, n - 1);
      if (modeChanged && !initial && a >= 0 && this._pointer == null && cfg.resetOnLeave) a = -1;
      this.active = -2;
      this.setActive(a, true);
      if (a >= 0) this._ensureVisible(a, true);
    }
    this._snapAll();
    this._updateNav();
  };

  P._targetX = function (i, a) {
    var L = this._L;
    if (this.mode === 'touch') {
      // peça aberta de frente afasta as vizinhas (que seguem de lado), como no computador
      var bx = L.pad + i * L.S + L.S / 2;
      if (a >= 0 && i !== a && L.E) bx += (i > a ? 1 : -1) * L.E;
      return bx;
    }
    var left;
    if (a < 0) left = L.offset + (L.A - L.R) / 2 + i * L.R;
    else left = L.offset + i * L.R + (i > a ? L.A - L.R : 0);
    return left + (i === a ? L.A : L.R) / 2;
  };

  // índice sob o cursor usando o layout-alvo (estável durante a animação)
  P._hitIndex = function (x, a) {
    var L = this._L, n = this.items.length;
    if (!L || this.mode !== 'desktop' || !n) return -1;
    var start = L.offset + (a < 0 ? (L.A - L.R) / 2 : 0);
    if (x < start) return -1;
    var acc = start;
    for (var i = 0; i < n; i++) {
      var wdt = i === a ? L.A : L.R;
      if (x < acc + wdt) return i;
      acc += wdt;
    }
    return -1;
  };
  P._touchIndexAt = function (x) {
    var L = this._L;
    if (!L || !L.S) return -1;
    if (this.active >= 0 && L.E) {               // com peça aberta: a mais próxima da posição atual
      var best = -1, bd = 1e9;
      for (var k = 0; k < this.items.length; k++) { var d = Math.abs(this._targetX(k, this.active) - x); if (d < bd) { bd = d; best = k; } }
      return best;
    }
    var i = Math.round((x - L.pad - L.S / 2) / L.S);
    return clamp(i, 0, this.items.length - 1);
  };

  P._ensureVisible = function (i, instant) {
    var L = this._L, sc = this.scroller;
    if (!L || L.stageW <= L.w) return;
    var cx = this._targetX(i, i), half = (L.A || L.S) / 2 + 24;
    var left = sc.scrollLeft, right = left + L.w;
    var to = null;
    if (cx - half < left + 48) to = cx - half - 48;
    else if (cx + half > right - 48) to = cx + half + 48 - L.w;
    if (to != null) this._scrollTo(to, instant);
  };
  P._scrollTo = function (x, instant) {
    var sc = this.scroller;
    x = clamp(x, 0, sc.scrollWidth - sc.clientWidth);
    if (instant || this.reduced || !sc.scrollTo) sc.scrollLeft = x;
    else sc.scrollTo({ left: x, behavior: 'smooth' });
  };
  P._page = function (dir) {
    this._scrollTo(this.scroller.scrollLeft + dir * this._w * 0.7);
  };
  P._updateNav = function () {
    var sc = this.scroller, max = sc.scrollWidth - sc.clientWidth;
    var l = sc.scrollLeft > 2, r = sc.scrollLeft < max - 2;
    this.root.classList.toggle('has-left', l && max > 2);
    this.root.classList.toggle('has-right', r && max > 2);
    this.btnPrev.disabled = !l;
    this.btnNext.disabled = !r;
  };

  P.scrollToIndex = function (i) {
    if (this.mode === 'touch') this._scrollTo(i * this._L.S);
    else { this.setActive(i); this._ensureVisible(i); }
  };
  P.next = function () { this.scrollToIndex(clamp((this.active < 0 ? -1 : this.active) + 1, 0, this.items.length - 1)); };
  P.prev = function () { this.scrollToIndex(clamp(this.active - 1, 0, this.items.length - 1)); };

  // ---------------------------------------------------------------- estado
  P.setActive = function (i, silent) {
    var n = this.items.length;
    i = i < 0 ? -1 : clamp(i, 0, n - 1);
    if (i === this.active) return;
    var prev = this.active;
    this.active = i;
    var self = this, cfg = this.config;

    this.items.forEach(function (it, k) {
      it.tp = k === i ? 1 : 0;
      if (it.label) it.label.classList.toggle('is-on', k === i && self.mode === 'desktop');
      it.tx = self._targetX(k, i);
      var z = k === i ? 30 : (k === prev ? 20 : 10);
      if (it.cache.z !== z) { it.el.style.zIndex = z; it.cache.z = z; }
      it.el.tabIndex = (k === (i < 0 ? self._lastFocus || 0 : i)) ? 0 : -1;
    });
    if (i >= 0) {
      this._lastFocus = i;
      // impulso do giro: leve balanço a partir do gancho
      if (!silent && !this.reduced && prev !== -2) {
        var dir = prev < 0 ? 1 : (i > prev ? 1 : -1);
        this.items[i].vth += 11 * cfg.sway * cfg.motion * dir;
      }
      this._preloadBack(i);
    }
    this.root.setAttribute('data-active', String(i));
    if (this.state === 'rest' || this.state === 'highlight') this._setState(i >= 0 ? 'highlight' : 'rest');
    this._caption(i);
    this._kick();
    if (!silent) this._emit('dbca:change', { index: i, product: i >= 0 ? this.products[i].data : null });
  };

  P._caption = function (i) {
    var a = this.nameEls[0], b = this.nameEls[1];
    var cur = a.classList.contains('is-current') ? a : b, nxt = cur === a ? b : a;
    var p = i >= 0 ? this.products[i] : null;
    var text = p ? p.title : (this.mode === 'touch' && this.config.labels.restTouch ? this.config.labels.restTouch : this.config.labels.rest);
    if (cur.textContent === text) return;
    nxt.textContent = text;
    nxt.classList.toggle('is-hint', !p);
    cur.classList.remove('is-current'); cur.setAttribute('aria-hidden', 'true');
    nxt.classList.add('is-current'); nxt.removeAttribute('aria-hidden');
    var sub = p ? [p.subtitle, this.config.showPriceTag ? '' : p.price].filter(Boolean).join('  ·  ') : '';
    this.subEl.textContent = sub;
    this.btnOpen.setAttribute('aria-label', p ? this.config.labels.openAria + ' ' + p.title : this.config.labels.open);
  };

  P._setState = function (s) {
    if (this.state === s) return;
    this.state = s;
    this.root.setAttribute('data-state', s);
  };

  P._emit = function (name, detail) {
    try { this.root.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true })); } catch (e) { /* IE */ }
  };

  // ---------------------------------------------------------------- física
  P._kick = function () {
    if (this._loop) return;
    var self = this;
    this._last = 0;
    this._loop = raf(function tick(t) {
      var dt = self._last ? Math.min((t - self._last) / 1000, 1 / 30) : 1 / 60;
      self._last = t;
      var moving = self._step(dt);
      self._render();
      if (moving) self._loop = raf(tick);
      else { self._loop = 0; }
    });
  };

  P._step = function (dt) {
    var cfg = this.config, red = this.reduced;
    var dur = Math.max(0.12, cfg.duration);
    var wx = 6.4 / dur, wp = 7.2 / dur;
    if (red) { wp = 24; }
    var kx = wx * wx, cx = 2 * wx, kp = wp * wp, cp = 2 * wp;
    // pêndulo: período ~1.15s, amortecido
    var kth = 30, cth = 3.4;
    var gain = red ? 0 : 0.0042 * cfg.sway * cfg.motion;
    var moving = false;
    var steps = 2, h = dt / steps;

    for (var s = 0; s < steps; s++) {
      for (var i = 0; i < this.items.length; i++) {
        var it = this.items[i];
        if (red) { it.x = it.tx; it.vx = 0; it.ax = 0; }
        else {
          var fx = kx * (it.tx - it.x) - cx * it.vx;
          it.vx += fx * h; it.x += it.vx * h; it.ax = fx;
        }
        var fp = kp * (it.tp - it.p) - cp * it.vp;
        it.vp += fp * h; it.p += it.vp * h;
        if (red) { it.th = 0; it.vth = 0; }
        else {
          var fth = -kth * it.th - cth * it.vth + gain * it.ax;
          it.vth += fth * h; it.th += it.vth * h;
          if (it.th > cfg.maxSway) { it.th = cfg.maxSway; it.vth *= -0.3; }
          if (it.th < -cfg.maxSway) { it.th = -cfg.maxSway; it.vth *= -0.3; }
        }
      }
    }
    for (var j = 0; j < this.items.length; j++) {
      var q = this.items[j];
      if (Math.abs(q.tx - q.x) > 0.08 || Math.abs(q.vx) > 0.5 ||
          Math.abs(q.tp - q.p) > 0.002 || Math.abs(q.vp) > 0.01 ||
          Math.abs(q.th) > 0.02 || Math.abs(q.vth) > 0.05) moving = true;
      else { q.x = q.tx; q.vx = 0; q.p = q.tp; q.vp = 0; q.th = 0; q.vth = 0; }
    }
    return moving;
  };

  P._snapAll = function () {
    this.items.forEach(function (it) {
      it.x = it.tx; it.vx = 0; it.p = it.tp; it.vp = 0; it.th = 0; it.vth = 0; it.cache.z = it.cache.z;
    });
    this._render();
  };

  P._render = function () {
    var cfg = this.config, L = this._L;
    if (!L) return;
    var turn = this.reduced ? 0 : cfg.turnAngle * Math.min(1, cfg.motion);
    var aScale = this.reduced ? 1 : cfg.activeScale;
    var half = L.IW / 2;
    for (var i = 0; i < this.items.length; i++) {
      var it = this.items[i], c = it.cache;
      var p = clamp(it.p, 0, 1);
      var ready = it.frontReady;

      var tItem = 'translate3d(' + (it.x - half).toFixed(2) + 'px,0,0)';
      if (c.item !== tItem) { it.el.style.transform = tItem; c.item = tItem; }

      var sc = 1 + (aScale - 1) * p;
      var tSw = 'rotate(' + it.th.toFixed(3) + 'deg) scale(' + sc.toFixed(4) + ')';
      if (c.sw !== tSw) { it.swing.style.transform = tSw; c.sw = tSw; }

      // A frente gira a partir do "fio" (quase de perfil) e só fica opaca quando
      // já é estreita como a lateral; a lateral some por baixo depois que a
      // frente a cobre. Assim não há fantasma nem queda de opacidade no meio.
      var fo = ready ? smooth(0.08, 0.34, p) : 0;
      var so = ready ? 1 - smooth(0.36, 0.58, p) : 1;
      if (this.reduced && ready) { fo = p; so = 1 - p; }
      var sideBase = it.sideFallback ? ' scaleX(' + cfg.fallbackSideScale + ')' : '';
      var tSide = 'perspective(1600px) rotateY(' + (p * turn * 0.35).toFixed(2) + 'deg)' + sideBase;
        var ang = turn * (1 - p * p);
      var tFront = 'perspective(1600px) rotateY(' + (-ang).toFixed(2) + 'deg)';
      if (c.tSide !== tSide) { it.side.style.transform = tSide; c.tSide = tSide; }
      if (c.tFront !== tFront) { it.front.style.transform = tFront; c.tFront = tFront; }
      var soS = so.toFixed(3), foS = fo.toFixed(3);
      if (c.so !== soS) { it.side.style.opacity = soS; c.so = soS; }
      if (c.fo !== foS) { it.front.style.opacity = foS; c.fo = foS; }
      var sh = (0.3 + 0.7 * p).toFixed(3);
      if (c.sh !== sh) { it.shadow.style.opacity = sh; c.sh = sh; }
    }
  };

  // ---------------------------------------------------------------- ampliada
  P._buildModal = function () {
    if (this.modal) return;
    var L = this.config.labels, id = this.id;
    var m = document.createElement('div');
    m.className = 'dbca-modal';
    m.hidden = true;
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', id + '-title');
    m.innerHTML =
      '<div class="dbca-modal-backdrop"></div>' +
      '<div class="dbca-modal-body">' +
        '<div class="dbca-modal-figure">' +
          '<img class="dbca-img dbca-modal-front is-shown" alt="" draggable="false" decoding="async">' +
          '<img class="dbca-img dbca-modal-back is-hidden" alt="" draggable="false" decoding="async">' +
        '</div>' +
        '<div class="dbca-modal-views" role="group" aria-label="' + esc(L.views) + '">' +
          '<button type="button" data-view="front" aria-pressed="true">' + esc(L.front) + '</button>' +
          '<button type="button" data-view="back" aria-pressed="false">' + esc(L.back) + '</button>' +
        '</div>' +
        '<div class="dbca-modal-info">' +
          '<h2 class="dbca-modal-title" id="' + id + '-title"></h2>' +
          '<p class="dbca-modal-sub"></p>' +
          '<p class="dbca-modal-price"></p>' +
          '<div class="dbca-modal-desc"></div>' +
        '</div>' +
        '<div class="dbca-modal-side">' +
          '<div class="dbca-modal-buy" hidden>' +
            '<span class="dbca-modal-label">' + esc(L.size || 'Tamanho') + '</span>' +
            '<div class="dbca-modal-sizes" role="group" aria-label="' + esc(L.size || 'Tamanho') + '"></div>' +
            '<button type="button" class="dbca-modal-cart"><span>' + esc(L.addCart || 'Adicionar ao carrinho') + '</span></button>' +
          '</div>' +
          '<div class="dbca-modal-actions" data-dbca-slot="product-link">' +
            '<a class="dbca-modal-link" hidden>' + esc(L.product) + '</a>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="dbca-modal-close" aria-label="' + esc(L.close) + '">' + ICON_CLOSE + '</button>' +
      '</div>';
    this._applyTheme(m);
    m.style.setProperty('--dbca-modal-h', this.config.modalHeight);
    m.style.setProperty('--dbca-modal-z', this.config.modalZIndex);
    // herda as variáveis de tema calculadas na raiz
    var cs = global.getComputedStyle(this.root);
    ['--dbca-text', '--dbca-muted', '--dbca-accent', '--dbca-font'].forEach(function (v) {
      var val = cs.getPropertyValue(v);
      if (val && !m.style.getPropertyValue(v)) m.style.setProperty(v, val.trim());
    });
    document.body.appendChild(m);

    this.modal = m;
    this.mFig = m.querySelector('.dbca-modal-figure');
    this.mFront = m.querySelector('.dbca-modal-front');
    this.mBack = m.querySelector('.dbca-modal-back');
    this.mTitle = m.querySelector('.dbca-modal-title');
    this.mSub = m.querySelector('.dbca-modal-sub');
    this.mPrice = m.querySelector('.dbca-modal-price');
    m.style.setProperty('--dbca-crop', String(1 - this.config.contentBottom));
    this.mInfo = m.querySelector('.dbca-modal-info');
    this.mBackdrop = m.querySelector('.dbca-modal-backdrop');
    this.mClose = m.querySelector('.dbca-modal-close');
    this.mLink = m.querySelector('.dbca-modal-link');
    this.mBuy = m.querySelector('.dbca-modal-buy');
    this.mSide = m.querySelector('.dbca-modal-side');
    this.mDesc = m.querySelector('.dbca-modal-desc');
    this.mViews = m.querySelector('.dbca-modal-views');
    this.mSizes = m.querySelector('.dbca-modal-sizes');
    this.mCart = m.querySelector('.dbca-modal-cart');
    this.mBtnFront = m.querySelector('[data-view="front"]');
    this.mBtnBack = m.querySelector('[data-view="back"]');

    var self = this;
    this._on(this.mClose, 'click', function () { self.close(); });
    this._on(this.mBackdrop, 'click', function () { self.close(); });
    // clique proposital fora da camisa (sem arrastar) também fecha
    var ox = null, oy = null;
    this._on(m, 'pointerdown', function (e) { ox = e.clientX; oy = e.clientY; });
    this._on(this.mBody || m.querySelector('.dbca-modal-body'), 'click', function (e) {
      if (self.state !== 'expanded') return;
      if (ox != null && Math.abs(e.clientX - ox) + Math.abs(e.clientY - oy) > 8) return;
      var t = e.target;
      if (t.closest && t.closest('.dbca-modal-info, .dbca-modal-close, .dbca-modal-side, .dbca-modal-views')) return;
      if (self.mFig.contains(t)) {
        var r = self.mFig.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        if (fx > 0.08 && fx < 0.92 && fy > 0.02 && fy < 0.98) return; // na camisa
      }
      self.close();
    });
    this._on(this.mSizes, 'click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-variant]');
      if (!b || b.disabled) return;
      Array.prototype.forEach.call(self.mSizes.querySelectorAll('button'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      self._variant = b.getAttribute('data-variant');
      self.mCart.disabled = false;
    });
    this._on(this.mCart, 'click', function () {
      if (!self._variant || self.mCart.disabled) return;
      var vid = +self._variant, L2 = self.config.labels;
      if (typeof global.addToCartShopify === 'function') { self.close(); setTimeout(function () { global.addToCartShopify(vid); }, 60); return; }
      self.mCart.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function () { self.mCart.firstChild.textContent = L2.added || 'Adicionado ✓'; })
        .catch(function () { self.mCart.disabled = false; });
    });
    this._on(this.mBtnFront, 'click', function () { self.setView('front'); });
    this._on(this.mBtnBack, 'click', function () { self.setView('back'); });
    this._on(m, 'keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        if (e.target === self.mBtnFront || e.target === self.mBtnBack) {
          e.preventDefault();
          var v = self.view === 'front' ? 'back' : 'front';
          self.setView(v);
          (v === 'front' ? self.mBtnFront : self.mBtnBack).focus();
        }
        return;
      }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(m.querySelectorAll('button, a[href]'), function (el) {
        return !el.disabled && !el.hidden && el.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!m.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    });
    // Escape funciona também durante a abertura (antes do foco entrar)
    this._on(document, 'keydown', function (e) {
      if (e.key !== 'Escape' || (self.state !== 'opening' && self.state !== 'expanded')) return;
      e.preventDefault();
      self.close();
    });
    // gesto horizontal na imagem ampliada alterna frente/costas
    var sx = null, sy = null;
    this._on(this.mFig, 'pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
    this._on(this.mFig, 'pointerup', function (e) {
      if (sx == null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) self.setView(self.view === 'front' ? 'back' : 'front');
    });
    this._on(this.mFig, 'pointercancel', function () { sx = null; });
  };

  P.setView = function (v) {
    if (!this.modal || (v === 'back' && this.mBtnBack.disabled)) return;
    if (this.view === v) return;
    this.view = v;
    var showBack = v === 'back';
    this.mFront.classList.toggle('is-shown', !showBack);
    this.mFront.classList.toggle('is-hidden', showBack);
    this.mBack.classList.toggle('is-shown', showBack);
    this.mBack.classList.toggle('is-hidden', !showBack);
    this.mBtnFront.setAttribute('aria-pressed', String(!showBack));
    this.mBtnBack.setAttribute('aria-pressed', String(showBack));
    this._emit('dbca:viewchange', { view: v, index: this.openIndex });
  };

  P._lockScroll = function (lock) {
    var html = document.documentElement, body = document.body;
    if (lock) {
      var sbw = global.innerWidth - html.clientWidth;
      this._scrollLock = { o: html.style.overflow, pr: body.style.paddingRight };
      html.style.overflow = 'hidden';
      if (sbw > 0) body.style.paddingRight = sbw + 'px';
    } else if (this._scrollLock) {
      html.style.overflow = this._scrollLock.o;
      body.style.paddingRight = this._scrollLock.pr;
      this._scrollLock = null;
    }
  };

  P.open = function (i, opener) {
    if (this.state !== 'rest' && this.state !== 'highlight') return;
    if (i == null) i = this.active;
    if (i < 0 || i >= this.items.length) return;
    this._clearLeave();
    if (i !== this.active) this.setActive(i, true);
    var it = this.items[i];
    // garante que a peça esteja de frente antes de medir
    it.p = 1; it.vp = 0; it.x = it.tx; it.vx = 0; it.cache = {};
    this._render();

    this._buildModal();
    var p = this.products[i], L = this.config.labels, self = this;
    this.openIndex = i;
    this._closeAfterOpen = false;
    this.opener = opener || document.activeElement;
    this._setState('opening');

    this.mTitle.textContent = p.title;
    this.mSub.textContent = p.subtitle || '';
    this.mSub.hidden = !this.mSub.textContent || !this.config.modalShowTitle;
    this.mTitle.classList.toggle('dbca-vh', !this.config.modalShowTitle);
    this.mPrice.textContent = p.price;
    this.mPrice.hidden = !p.price;
    var mi = (p.data && p.data.modal) || {};
    var fig = this.mFig;
    this.mFront.onload = function () { if (this.naturalWidth) { fig.style.aspectRatio = this.naturalWidth + ' / ' + this.naturalHeight; fig.style.setProperty('--fig-r', (this.naturalWidth / this.naturalHeight).toFixed(4)); } };
    fig.style.aspectRatio = mi.ratio || '';
    this.mFront.src = mi.front ? this._resolve(mi.front) : (it.front.currentSrc || it.front.src);
    this.mDesc.textContent = (p.data && p.data.description) || '';
    this.mDesc.hidden = !this.mDesc.textContent;
    this.view = 'back'; this.setView('front');
    // costas: carregadas sob demanda
    this.mBack.onload = null; this.mBack.onerror = null;
    this.mBack.removeAttribute('src');
    this.mBack.classList.add('is-loading');
    this.mViews.hidden = !p.images.back;   // peça só com frente: sem o seletor
    if (p.images.back) {
      this.mBack.onload = function () { self.mBack.classList.remove('is-loading'); };
      this.mBtnBack.disabled = false;
      this.mBtnBack.textContent = L.back;
      this.mBack.onerror = function () {
        self.mBtnBack.disabled = true;
        self.mBtnBack.textContent = L.backMissing;
        if (self.view === 'back') self.setView('front');
      };
      this.mBack.src = mi.back ? this._resolve(mi.back) : p.images.back;
    } else {
      this.mBack.removeAttribute('src');
      this.mBtnBack.disabled = true;
      this.mBtnBack.textContent = L.backMissing;
    }
    if (p.url) { this.mLink.href = p.url; this.mLink.hidden = false; }
    else { this.mLink.removeAttribute('href'); this.mLink.hidden = true; }
    // tamanhos e carrinho
    var vs = (p.data && p.data.variants) || [];
    this._variant = null;
    this.mSizes.innerHTML = '';
    if (vs.length) {
      var avail = vs.filter(function (v) { return v.available; });
      vs.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('data-variant', v.id); b.setAttribute('aria-pressed', 'false');
        b.textContent = v.size || v.title; b.disabled = !v.available;
        self.mSizes.appendChild(b);
      });
      if (avail.length === 1) { this._variant = String(avail[0].id); this.mSizes.querySelector('button[data-variant="' + avail[0].id + '"]').setAttribute('aria-pressed', 'true'); }
      this.mSizes.hidden = vs.length < 2;
      this.mCart.firstChild.textContent = avail.length ? (L.addCart || 'Adicionar ao carrinho') : (L.soldOut || 'Esgotado');
      this.mCart.classList.toggle('is-sold', !avail.length);
      this.mCart.disabled = !avail.length || !this._variant;
      this.mBuy.hidden = false;
    } else this.mBuy.hidden = true;

    var src = it.front.getBoundingClientRect();
    this._lockScroll(true);
    this.modal.hidden = false;
    var dst = this.mFig.getBoundingClientRect();
    it.el.classList.add('is-lifted');
    this.mClose.focus({ preventScroll: true });

    var D = this.reduced ? 160 : this.config.openDuration * 1000;
    var ease = 'cubic-bezier(.22,.8,.22,1)';
    this._anims = [];
    if (this.mFig.animate) {
      var from = this.reduced ? 'none' : 'translateY(70px) scale(.9)';
      this._anims.push(this.mFig.animate([{ transform: from, opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: D, easing: ease }));
      this._anims.push(this.mViews.animate([{ opacity: 0 }, { opacity: 1 }], { duration: D * 0.5, delay: D * 0.5, fill: 'backwards' }));
      this._anims.push(this.mSide.animate([{ opacity: 0, transform: 'translateX(14px)' }, { opacity: 1, transform: 'none' }], { duration: D * 0.6, delay: D * 0.5, easing: 'ease-out', fill: 'backwards' }));
      this._anims.push(this.mBackdrop.animate([{ opacity: 0 }, { opacity: 1 }], { duration: D * 0.8, easing: 'ease-out' }));
      this._anims.push(this.mInfo.animate([{ opacity: 0, transform: 'translateX(-14px)' }, { opacity: 1, transform: 'none' }],
        { duration: D * 0.6, delay: D * 0.45, easing: 'ease-out', fill: 'backwards' }));
      this._anims.push(this.mClose.animate([{ opacity: 0 }, { opacity: 1 }], { duration: D * 0.5, delay: D * 0.4, fill: 'backwards' }));
    }
    var done = function () {
      if (self.state !== 'opening') return;
      self._setState('expanded');
      if (self._closeAfterOpen) { self._closeAfterOpen = false; self.close(); return; }
      if (!self.modal.contains(document.activeElement)) self.mClose.focus({ preventScroll: true });
      self._emit('dbca:open', { index: i, product: p.data });
    };
    if (this._anims.length) this._anims[0].finished.then(done, done); else done();
  };

  P._flip = function (src, dst) {
    if (!dst.width || !dst.height) return 'none';
    var sx = src.width / dst.width, sy = src.height / dst.height;
    return 'translate(' + (src.left - dst.left) + 'px,' + (src.top - dst.top) + 'px) scale(' + sx + ',' + sy + ')';
  };

  P.close = function () {
    if (this.state === 'opening') { this._closeAfterOpen = true; return; }
    if (this.state !== 'expanded') return;
    var self = this, it = this.items[this.openIndex];
    this._setState('closing');
    if (this.view === 'back') this.setView('front');
    var D = this.reduced ? 140 : this.config.openDuration * 900;
    var ease = 'cubic-bezier(.4,0,.2,1)';
    var finish = function () {
      if (self.state !== 'closing') return;
      self.modal.hidden = true;
      it.el.classList.remove('is-lifted');
      self._lockScroll(false);
      self._setState(self.active >= 0 ? 'highlight' : 'rest');
      var op = self.opener;
      if (op && op.isConnected && op.focus) op.focus({ preventScroll: true });
      self.opener = null;
      self._emit('dbca:close', { index: self.openIndex });
    };
    if (!this.mFig.animate) return finish();
    var src = it.front.getBoundingClientRect();
    var dst = this.mFig.getBoundingClientRect();
    var a1 = this.mFig.animate([{ transform: 'none', opacity: 1 }, { transform: this.reduced ? 'none' : 'translateY(50px) scale(.94)', opacity: 0 }], { duration: D * 0.8, easing: ease, fill: 'forwards' });
    this.mSide.animate([{ opacity: 1 }, { opacity: 0 }], { duration: D * 0.35, fill: 'forwards' });
    this.mViews.animate([{ opacity: 1 }, { opacity: 0 }], { duration: D * 0.35, fill: 'forwards' });
    this.mBackdrop.animate([{ opacity: 1 }, { opacity: 0 }], { duration: D, easing: 'ease-in', fill: 'forwards' });
    this.mInfo.animate([{ opacity: 1 }, { opacity: 0 }], { duration: D * 0.35, fill: 'forwards' });
    this.mClose.animate([{ opacity: 1 }, { opacity: 0 }], { duration: D * 0.35, fill: 'forwards' });
    a1.finished.then(function () {
      finish();
      // limpa os estados "fill: forwards" para a próxima abertura
      [self.mFig, self.mBackdrop, self.mInfo, self.mClose, self.mSide, self.mViews].forEach(function (el) {
        el.getAnimations && el.getAnimations().forEach(function (a) { a.cancel(); });
      });
    }, finish);
  };

  // ---------------------------------------------------------------- API
  P.update = function (products) {
    var keepActive = this.active;
    this.products = this._normalize(products || []);
    this._unbind();
    this._build();
    this._bind();
    this.mode = null;
    this.active = -1;
    this._measure(true);
    if (keepActive >= 0 && keepActive < this.items.length && this.mode === 'desktop') this.setActive(keepActive, true);
  };

  // altera parâmetros em tempo real (ex.: painel de ajuste)
  P.setConfig = function (partial) {
    var cfg = this.config;
    for (var k in partial) {
      if (k === 'theme') { cfg.theme = merge(cfg.theme, partial.theme); this._applyTheme(this.root); }
      else if (k === 'labels') cfg.labels = merge(cfg.labels, partial.labels);
      else cfg[k] = partial[k];
    }
    var a = this.active;
    this.mode = null;
    this._measure(true);
    if (a >= 0 && this.mode === 'desktop') { this.setActive(a, true); this._snapAll(); }
  };

  P._unbind = function () {
    this._ls.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    this._ls = [];
    if (this._legacyMq && this._mqReduce.removeListener) this._mqReduce.removeListener(this._legacyMq);
    if (this._ro) { this._ro.disconnect(); this._ro = null; }
    if (this._loop) { caf(this._loop); this._loop = 0; }
    if (this._scrollRaf) { caf(this._scrollRaf); this._scrollRaf = 0; }
    if (this._roRaf) { caf(this._roRaf); this._roRaf = 0; }
    this._clearLeave();
    if (this.modal) { this.modal.remove(); this.modal = null; }
    this._lockScroll(false);
    this.state = 'rest';
  };

  P.destroy = function () {
    this._unbind();
    var r = this.root;
    r.innerHTML = this._originalHTML;
    r.className = this._originalClass;
    if (this._originalStyle == null) r.removeAttribute('style'); else r.setAttribute('style', this._originalStyle);
    ['data-state', 'data-active', 'data-mode'].forEach(function (a) { r.removeAttribute(a); });
    delete r.__dbcRail;
  };

  DBCRail.defaults = DEFAULTS;
  DBCRail.autoInit = function (scope) {
    var els = (scope || document).querySelectorAll('[data-dbc-rail]');
    return Array.prototype.map.call(els, function (el) { return el.__dbcRail || new DBCRail(el); });
  };

  global.DBCRail = DBCRail;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { DBCRail.autoInit(); });
  else DBCRail.autoInit();
})(window);
